import { useMutation } from "@tanstack/react-query";
import { forgotPassword, login, register, resetPassword } from "./requests";

export const useLoginMutation = (onSuccess: (response: any) => void, onError: (error: any) => void) =>
  useMutation({ 
    mutationKey: ['auth', 'login'], 
    mutationFn: (payload: { email: string; password: string }) => login(payload),
    onSuccess,
    onError
  });

export const useRegisterMutation = (onSuccess: (response: any) => void, onError: (error: any) => void) =>
  useMutation({ 
    mutationKey: ['auth', 'register'], 
    mutationFn: (payload: { email: string; password: string; inviteToken: string }) => register(payload),
    onSuccess,
    onError
  });

export const useForgotPasswordMutation = (onSuccess: (response: any) => void, onError: (error: any) => void) =>
  useMutation({ 
    mutationKey: ['auth', 'forgot-password'], 
    mutationFn: (payload: { email: string }) => forgotPassword(payload),
    onSuccess,
    onError
  });

export const useResetPasswordMutation = (onSuccess: (response: any) => void, onError: (error: any) => void) =>
  useMutation({ 
    mutationKey: ['auth', 'reset-password'], 
    mutationFn: (payload: { email: string; newPassword: string; token: string }) => resetPassword(payload),
    onSuccess,
    onError
  });